import gql from "graphql-tag";
import GraphQLClient, { RequestParam } from "../api";
import { Wallet } from "../models/nolaCoin";
import { logError, createApiLogContext } from "../utils/logger";

/**
 * NolaCoin API クライアントインターフェース
 */
interface INolaCoinClient {
  getWallet: () => Promise<Wallet>;
}

/**
 * NolaCoin API クライアント
 * コイン残高情報の取得を行う
 */
export class NolaCoinClient implements INolaCoinClient {
  /**
   * ウォレット情報を取得
   * Fish残高として使用される現在のコイン残高を取得
   *
   * @returns Promise<Wallet> ウォレット情報（残高含む）
   */
  async getWallet(): Promise<Wallet> {
    const params: RequestParam = {
      query: getWalletQuery,
    };

    try {
      const { getWallet } = await GraphQLClient.request(params);
      return getWallet;
    } catch (error: unknown) {
      logError(createApiLogContext("NolaCoin", "ウォレット情報取得"), "ウォレット情報の取得に失敗しました", error);
      throw error;
    }
  }
}

/**
 * GraphQL クエリ定義
 */

const getWalletQuery = gql`
  query GetWallet {
    getWallet {
      userId
      amount
      totalAmount
      walletBreakdown {
        coinType
        amount
      }
    }
  }
`;
